import { useFieldSet } from "@/components/utils/useFieldSet";
import {
  JobAppAddressInformationRequest,
  JobAppSectionResponseSectionType,
} from "modules/api-docs";
import {
  addressInfoOptionalYup,
  addressInfoRequiredYup,
} from "modules/self-apply/validation/candidate-self-apply";
import { useMemo } from "react";
import {
  SelfApplyOnlyBaseJobAppSectionFieldSetArgs,
  SelfApplyOnlyNullishExistingJobApp,
  SelfApplyOnlyNullishJobSection,
  selfApplyOnlyBaseIsSectionRequired,
} from "./common";

export function isAddressInfoRequired(
  jobSections: SelfApplyOnlyNullishJobSection[],
) {
  return selfApplyOnlyBaseIsSectionRequired(
    jobSections,
    JobAppSectionResponseSectionType.ADDRESS_INFORMATION,
  );
}

export function extractAddressInfoFromExistingJobApp(args: {
  existingJobApp: SelfApplyOnlyNullishExistingJobApp;
}): JobAppAddressInformationRequest {
  return {
    addressLineOne: args.existingJobApp?.addressLineOne ?? undefined,
    addressLineTwo: args.existingJobApp?.addressLineTwo ?? undefined,
    city: args.existingJobApp?.city ?? undefined,
    state: args.existingJobApp?.state ?? undefined,
    zipCode: args.existingJobApp?.zipCode ?? undefined,
    country: args.existingJobApp?.country ?? undefined,
  };
}

type UseAddressInfoFieldSetArgs = SelfApplyOnlyBaseJobAppSectionFieldSetArgs;
export function useAddressInfoFieldSet({
  jobSections,
  existingJobApp,
}: UseAddressInfoFieldSetArgs) {
  const initialValue = useMemo(() => {
    return extractAddressInfoFromExistingJobApp({ existingJobApp });
  }, [existingJobApp]);

  return useFieldSet<JobAppAddressInformationRequest>(
    initialValue,
    [initialValue],
    isAddressInfoRequired(jobSections)
      ? addressInfoRequiredYup
      : addressInfoOptionalYup,
  );
}
